export default "__VITE_ASSET__Dh11qy24__"